import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Theme,
  ThemeProvider,
} from '@mui/material';
import { createRoot } from 'react-dom/client';

export interface IConfirmDialogComponentProps {
  unmount: (confirmed: boolean) => void;
  title: string;
  subText: string;
  confirmButtonText: string;
  abortButtonText: string;
}

export const showConfirmDialogComponent = (
  title: string,
  subText: string,
  confirmButtonText: string,
  abortButtonText: string,
  theme: Theme
): Promise<boolean> => {
  const ConfirmDialogComponent = ({
    unmount,
  }: IConfirmDialogComponentProps) => {
    return (
      <ThemeProvider theme={theme}>
        <Dialog open={true} onClose={() => unmount(false)} maxWidth='sm'>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{subText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={() => unmount(false)}>
              {abortButtonText}
            </Button>
            <Button variant='contained' onClick={() => unmount(true)} autoFocus>
              {confirmButtonText}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  return new Promise<boolean>(resolve => {
    const reactContainer = document.createElement('div');
    document.body.appendChild(reactContainer);
    const root = createRoot(reactContainer);

    const unmount = (confirmed: boolean) => {
      root.unmount();
      document.body.removeChild(reactContainer);
      resolve(confirmed);
    };

    root.render(
      <ConfirmDialogComponent
        unmount={unmount}
        title={title}
        subText={subText}
        confirmButtonText={confirmButtonText}
        abortButtonText={abortButtonText}
      />
    );
  });
};
